import React from 'react';
import {Button, withStyles,} from '@material-ui/core';
import {FirstIcon, LastIcon, NextArrow, PreviousArrow, UpArrow} from "../../../../../helpers/Icons";
import ToolbarButtonGroup from "../../../../../helpers/ToolbarButtonGroup";

const styles = {
  topBarWrapper:{
    display: "flex",
    flexWrap: "wrap",
    gap: "0.25rem",
    alignItems: "center",
    fontWeight: 600,
    justifyContent:"space-evenly",
  },
  title: {
    whiteSpace: "nowrap",
    flex: 1,
    display: "flex",
    alignItems: "center",
    gap: "0.5rem"
  },
  middle:{
    display: "flex",
    gap: "0.25rem",
    justifyContent:"center",
    flex: 1,
    alignItems: "center",
  },
  numberLabel: {
    fontWeight: '500',
    whiteSpace: "nowrap",
  },
  topRight:{
    flex: 1,
    textAlign: "right",
    height: "1.75rem",
  },
  button: {
    height: "1.75rem !important",
  },
  iconButton: {
    height: "1.75rem !important",
    paddingLeft: "0.5rem !important",
    paddingRight: "0.5rem !important",
    minWidth: "fit-content !important",
    '& span:first-child > span:nth-child(1)':{
      marginLeft: "0 !important",
      marginRight: "0 !important",
    },
  },
  number: { },
}
function QuestionNavigation(props) {
  const { surveyAttempt, survey, questionIndex, jumpToQuestion, classes } = props;
  const surveyComplete = surveyAttempt.answer_count >= survey.question_count;
  const showingResults = questionIndex >= survey.question_count;

  return (
    <div className={classes.topBarWrapper}>
      <div id="surveyName" className={classes.title}>{survey.name}</div>
      <div className={classes.middle}>
        {questionIndex === survey.question_count ?
          <span id={"questionTitle"} className={classes.numberLabel}>Results</span>
        : <span id={"questionTitle"} className={classes.numberLabel}>
            Question <span id={"currentQuestion"} className={classes.number}>{questionIndex + 1}</span> (<span id={"currentQuestionPercent"}>{((questionIndex/survey.question_count)*100).toFixed(1)}</span>%)
          </span>
        }
      </div>
      <div id="surveyNav" className={classes.topRight}>
        <ToolbarButtonGroup style={{flexWrap: "nowrap", textAlign: "right", backgroundColor: "#fff",}}>
          <Button
            id={"navFirstQuestion"}
            disabled={questionIndex === 0}
            title={"First Question"}
            className={!showingResults ? classes.iconButton : classes.button}
            startIcon={<FirstIcon />}
            onClick={() => jumpToQuestion(0)}
          >{showingResults ? "First" : null}</Button>
          {questionIndex >= survey.question_count ? null :
            <Button
              id={"navPreviousQuestion"}
              disabled={questionIndex === 0}
              title={"Previous Question"}
              className={classes.button}
              startIcon={<PreviousArrow />}
              onClick={() => jumpToQuestion(questionIndex - 1)}
            >Prev</Button>
          }
          {questionIndex >= survey.question_count ? null :
            <Button
              id={"navNextQuestion"}
              title={"Next Question"}
              disabled={!surveyComplete ? questionIndex >= surveyAttempt.answer_count : questionIndex >= surveyAttempt.answer_count - 1}
              className={classes.button}
              endIcon={<NextArrow />}
              onClick={() => jumpToQuestion(questionIndex + 1)}
            >Next</Button>
          }
          {/*{questionIndex < surveyAttempt.answer_count - 1 || showingResults ?*/}
          <Button
            id={"navLastQuestion"}
            title={"Last Question"}
            disabled={!surveyComplete ? questionIndex === surveyAttempt.answer_count : questionIndex === surveyAttempt.answer_count - 1}
            className={!showingResults ? classes.iconButton : classes.button}
            endIcon={<LastIcon />}
            onClick={() => jumpToQuestion(!surveyComplete ? surveyAttempt.answer_count : surveyAttempt.answer_count - 1)}
          >{showingResults ? "Last" : null}</Button>

          {(surveyComplete || !!surveyAttempt.results) && !showingResults ?
            <Button
              id={"navResult"}
              title={"View Survey Results"}
              className={classes.button}
              startIcon={<UpArrow />}
              onClick={() => jumpToQuestion(survey.question_count)}
            >Results</Button>
            : null
          }
          {!surveyComplete && showingResults ?
            <Button
              id={"navResume"}
              title={"Resume Survey"}
              className={classes.button}
              startIcon={<PreviousArrow />}
              onClick={() => jumpToQuestion(surveyAttempt.answer_count)}
            >Resume</Button>
            : null
          }
        </ToolbarButtonGroup>
      </div>
    </div>
  )
}

export default withStyles(styles)(QuestionNavigation);